// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aeaee3d5","455":"d4613431","977":"e7ed54f3"}[chunkId] + ".chunk.js";
};